import { Component, ViewChild } from '@angular/core';
import { App, Nav, Platform, AlertController, Events, ToastController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { MenuController} from 'ionic-angular'
// import { OneSignal} from '@ionic-native/onesignal';
import { Network } from '@ionic-native/network';
import { HttpProvider } from '../providers/http/http';
import { LoginPage } from '../pages/login/login';
import { transition, trigger, animate, state, style } from '@angular/animations';
import { Geolocation } from '@ionic-native/geolocation';
import { TabsPage } from '../pages/tabs/tabs';
import { CobrosPage } from '../pages/cobros/cobros';
import { EsperaPage } from '../pages/espera/espera';
import { ReportesPage } from '../pages/reportes/reportes';
import { SolicitudesPage } from '../pages/solicitudes/solicitudes';
import { Tabs2Page } from '../pages/tabs2/tabs2';
import { DevolucionesPage } from '../pages/devoluciones/devoluciones';
import { ProyeccionesPage } from '../pages/proyecciones/proyecciones';
import { ResumenPage } from '../pages/resumen/resumen';
import moment from 'moment';
import { CxcPage } from '../pages/cxc/cxc';
@Component({
  selector:'page-app',
  templateUrl: 'app.html',
  animations:[
    trigger('cat',[
      state('open', style({
        opacity:1,
        display:'initial'
      })),
      state('close', style({
        opacity:0,
        display:'none'
      })),
      transition('open=>close',animate('1s')),
      transition('close=>open',animate('1s')),
    ])
  ]
  
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  bounce: any
  rootPage: any ;
  categorias: any = [];
  pages: Array<{title: string, component: any, icon:string}>;
  plat:any=''
  id: any = ''
  titulo: any = 'Menu'
  cat: any = false
  cont = 0
  super: any = false
  constructor(
    public http: HttpProvider,
    public platform: Platform, 
    public statusBar: StatusBar, 
    public app: App,
    private geolocation: Geolocation,
    public splashScreen: SplashScreen, 
    public menuCtrl: MenuController, 
    // public onesignal: OneSignal,
    public alrtCtrl: AlertController,
    public events: Events,
    public network: Network,
    public toastCtrl: ToastController
    ) {
    window.localStorage.setItem('network', '1')
    if(window.localStorage.getItem('id')){
      this.rootPage = TabsPage
    } else{
      this.rootPage = LoginPage
    } 
    this.initializeApp();
    this.updateConnection()
    this.ubicacionVen()
    this.guardarVersion()
    events.subscribe('user:login',()=>{
      this.udpate()  
      this.guardarVersion()
    })
    this.udpate()  
    // used for an example of ngFor and navigation

    this.platform.is('ios')?this.plat='ios':this.plat='android'
  }

  updateConnection(){
    this.network.onConnect().subscribe(
      () => {
        window.localStorage.setItem('network','1')
        // this.cont++
        // if (this.cont === 1) {
        //   setTimeout(function() {
        //     if(window.localStorage.pedidos && JSON.parse(window.localStorage.pedidos).length > 0){
        //       this.http.post('pedido/pendientes', JSON.parse(window.localStorage.pedidos)).subscribe(
        //         (res: any) => {
        //           window.localStorage.setItem('pedidos', JSON.stringify([]));
        //           if (res.error) {
        //             this.toastCtrl.create({
        //               duration: 4000,
        //               message: res.error
        //             }).present()
        //           } else {
        //             this.toastCtrl.create({
        //               duration: 4000,
        //               message:'Los pedidos pendientes han sido enviados'
        //             }).present()
        //           }
        //           this.cont = 0
        //         },
        //         err => {
        //           this.cont = 0
        //           this.toastCtrl.create({
        //             duration: 4000,
        //             message:'Ha ocurrido un error al enviar los pedidos en memoria, cambie de red o ingrese al modulo de pedidos para generarlos de forma manual.'
        //           }).present()
        //         }
        //       )
        //     } else {
        //       this.cont = 0
        //     }
        //   }.bind(this), 5000);
        // }
      }
    )
    this.network.onDisconnect().subscribe(
      () => {
        window.localStorage.setItem('network', '0')
        this.toastCtrl.create({
          duration: 4000,
          position: 'top',
          message:'Su telefono esta desconectado, la información que vea puede no estar actualizada'
        }).present()
      }
    )
  }

  udpate(){
    if(window.localStorage.getItem('id')){
      this.id = window.localStorage.getItem('id')
    }
    if(window.localStorage.getItem('super')){
      this.super = true
    }else{
      this.super = false
    }
    if(this.super){
      this.pages = [
        {title: 'Inicio', component: "Dashboard", icon: '../../assets/iconsvg/iconohome.svg'},
        {title: 'Clientes', component: "Clientes", icon: '../../assets/iconsvg/iconoclientes.svg'},
        // {title: 'Vendedores', component: "Vendedores", icon: '../../assets/iconsvg/iconovendedorsinrelleno.svg'},
        {title: 'Pedidos', component: "Pedidos", icon: '../../assets/iconsvg/iconopedido.svg'},
        {title: 'Pedidos en espera', component: "Espera", icon: '../../assets/iconsvg/pedidoenespera.svg'},
        {title: 'Proyección de ventas', component: "Proyecciones", icon: '../../assets/iconsvg/estadistica_azul.svg'},
        {title: 'Resumen', component: "Resumen", icon: '../../assets/iconsvg/resumen_deuda_azul.svg'},
        {title: 'CXC', component: "Cxc", icon: '../../assets/iconsvg/estado_cuenta_azul.svg'},
        {title: 'Solicitud de devolución', component: "Devoluciones", icon: '../../assets/iconsvg/sinordenazul.svg'},
        {title: 'Reportes', component: "Reportes", icon: '../../assets/iconsvg/reporte.svg'},
        {title: 'Solicitud código de cliente', component: "Solicitudes", icon: '../../assets/iconsvg/solicitud.svg'},
        // {title: 'Artículos', component: "Articulos", icon: '../../assets/iconsvg/iconoarticulos.svg'},
        {title: 'Cobros', component: "Cobros", icon: '../../assets/iconsvg/cobrosinrelleno.svg'},
      ];
    } else {
      this.pages = [
        {title: 'Inicio', component: "Dashboard", icon: '../../assets/iconsvg/iconohome.svg'},
        {title: 'Clientes', component: "Clientes", icon: '../../assets/iconsvg/iconoclientes.svg'},
        {title: 'Pedidos', component: "Pedidos", icon: '../../assets/iconsvg/iconopedido.svg'},
        {title: 'Pedidos en espera', component: "Espera", icon: '../../assets/iconsvg/pedidoenespera.svg'},
        {title: 'Resumen', component: "Resumen", icon: '../../assets/iconsvg/resumen_deuda_azul.svg'},
        {title: 'CXC', component: "Cxc", icon: '../../assets/iconsvg/estado_cuenta_azul.svg'},
        {title: 'Devoluciones', component: "Devoluciones", icon: '../../assets/iconsvg/sinordenazul.svg'},
        {title: 'Reportes', component: "Reportes", icon: '../../assets/iconsvg/reporte.svg'},
        {title: 'Solicitudes de código', component: "Solicitudes", icon: '../../assets/iconsvg/solicitud.svg'},
        // {title: 'Artículos', component: "Articulos", icon: '../../assets/iconsvg/iconoarticulos.svg'},
        {title: 'Cobros', component: "Cobros", icon: '../../assets/iconsvg/cobrosinrelleno.svg'},
      ];
    }
  }

  showCat(){
    this.cat === true ? this.cat = false : this.cat = true
  }

  initializeApp() {
    this.platform.ready().then(() => {    
      if(window.localStorage.getItem('id')){
        this.id = window.localStorage.getItem('id')
        if (window.localStorage.getItem('super')) {
          if (window.localStorage.getItem('resumen') && window.localStorage.getItem('resumen') == moment().format('DD-MM-YYYY').toString()) {
            this.rootPage = TabsPage
          } else {
            window.localStorage.setItem('showMenuResumen', "NO")
            this.rootPage = ResumenPage
          }
        } else {
          if (window.localStorage.getItem('resumen') && window.localStorage.getItem('resumen') == moment().format('DD-MM-YYYY').toString()) {
            this.rootPage = Tabs2Page
          } else {
            window.localStorage.setItem('showMenuResumen', "NO")
            this.rootPage = ResumenPage
          }
        }
      }
      this.statusBar.overlaysWebView(true)
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    })
    .catch(error=>console.log(error));
  }

  ir(item){
    this.menuCtrl.close()
    if (item === "Espera") {
      this.app.getActiveNavs()[0].push(EsperaPage)
    } else if (item === "Reportes") {
      this.app.getActiveNavs()[0].push(ReportesPage)
    } else if (item === "Cobros")  {
      this.app.getActiveNavs()[0].push(CobrosPage)
    } else if (item === "Proyecciones") {
      this.app.getActiveNavs()[0].push(ProyeccionesPage)
    } else if (item === "Devoluciones")  {
      this.app.getActiveNavs()[0].push(DevolucionesPage)
    } else if (item === "Cxc") {
      this.app.getActiveNavs()[0].push(CxcPage)
    } else if (item === "Resumen") {
      this.app.getActiveNavs()[0].push(ResumenPage)
    } else if (item === "Solicitudes") {
      this.app.getActiveNavs()[0].push(SolicitudesPage)
    } else {
      if (window.localStorage.getItem('super')) {
        this.nav.setRoot(TabsPage, {value: item})
      } else {
        this.nav.setRoot(Tabs2Page, {value: item})
      }
    }
  }

  guardarVersion() {
    if(window.localStorage.getItem('network') === '1') {
      if (window.localStorage.getItem('co_ven')) {
        let info = {
          co_ven: window.localStorage.getItem('co_ven'),
          version: "0.3"
        }
        this.http.post('version', info).subscribe((res:any)=> {
          console.log(res)
        })
      }
    }
  }
  
  ubicacionVen() {
    if(window.localStorage.getItem('network') === '1') {
      if (window.localStorage.getItem('co_ven')) {
        let options = {
          enableHighAccuracy: true
        }
        this.geolocation.getCurrentPosition(options).then((resp) => {
          let info = {
            co_ven: window.localStorage.getItem('co_ven'),
            coordenadas: {
              lat: resp.coords.latitude,
              lng: resp.coords.longitude
            }
          }
          this.http.post('ubicacion', info).subscribe((res:any)=> {
            console.log(res)
          })
        })
      }
    }
    setTimeout(async()=>{
      this.ubicacionVen()
    }, 10000)
  }

  closeMenu(){
    this.menuCtrl.close()
  }

  iniciarSesion(){
    this.nav.push(LoginPage)
    this.menuCtrl.close()
  }

  cerrarSesion(){
    this.alrtCtrl.create({
      title: 'Atención',
      subTitle: '¿Seguro que desea cerrar sesión?',
      cssClass:'alrt',
      buttons:[
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'btn'
        },
        {
          text:'Aceptar',
          cssClass: 'btnAceptar',
          handler:()=>{
            window.localStorage.clear()
            window.localStorage.network = '1'
            this.id = ''
            this.titulo = 'Menu'
            this.menuCtrl.close()
            this.nav.setRoot(LoginPage)
          }
        }
      ]
    }).present()
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts